<template>
  <div class="questions" :style="listZoom" :class="`questionsZoom`">
    <div
      v-for="(question, index) in questionsData"
      :key="index"
      class="item"
      :ref="`questionScroll-${question.id}`"
    >
      <div class="exam-question" style="display: flex">
        <div style="flex: 1 1 auto">
          <span>
            {{ index + 1 }}.
            {{ question.topic }}
          </span>
        </div>
        <div
          class="tool"
          style="
            display: block;
            flex: 0 1;
            padding-left: 10px;
            text-align: right;
            min-width: 100px;
          "
        >
          <span
            >(<i>{{ question.score }}分</i>)</span
          >
        </div>
      </div>
      <div class="answers">
        <ul class="questions-list" style="padding: 0 20px">
          <li v-for="(option, optIndex) in question.options" :key="optIndex">
            <div style="margin-left: 8px" class="context">
              <!-- {{ question.selecteds }} -->
              <template v-if="question.questionType === 1">
                <el-radio
                  v-model="question.selecteds[0]"
                  :label="(optIndex + 1) | numberToLetter"
                  style="width: 100%"
                  @change="handleChage($event, question)"
                  >{{ (optIndex + 1) | numberToLetter }}.
                  {{ option.value }}</el-radio
                >
              </template>
              <template v-if="question.questionType === 2">
                <el-checkbox
                  v-model="question.selecteds"
                  :label="(optIndex + 1) | numberToLetter"
                  style="width: 100%"
                  @change="handleChage($event, question)"
                  >{{ (optIndex + 1) | numberToLetter }}.
                  {{ option.value }}</el-checkbox
                ></template
              >
              <template v-if="question.questionType === 3">
                <el-radio
                  v-model="question.selecteds[0]"
                  :label="(optIndex + 1) | numberToLetter"
                  style="width: 100%"
                  @change="handleChage($event, question)"
                  >{{ (optIndex + 1) | numberToLetter }}.
                  {{ option.value }}</el-radio
                ></template
              >

              <!-- <el-radio label="1" style="width: 100%">
                {{ (optIndex + 1) | numberToLetter }}. {{ option.value }}
              </el-radio> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Questions",
  props: {
    questionsData: {
      type: Array,
      default() {
        return [];
      },
    },
    zoom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },

  computed: {
    listZoom() {
      return {
        "--fontSize": `${16 * (this.zoom / 100) + 16}px`,
        "--width": `${14 * (this.zoom / 100) + 14}px`,
        "--height": `${14 * (this.zoom / 100) + 14}px`,
        "--radioWidth": `${4 * (this.zoom / 100) + 4}px`,
        "--radioHeight": `${4 * (this.zoom / 100) + 4}px`,
        "--checkboxWidth": `${3 * (this.zoom / 100) + 3}px`,
        "--checkboxHeight": `${7 * (this.zoom / 100) + 7}px`,
        "--checkboxLeft": `${4 * (this.zoom / 100) + 4}px`,
        "--checkboxBorder": `${2 * (this.zoom / 100) + 2}px`,
      };
    },
  },

  methods: {
    scrollToAnchor(anchor) {
      this.$nextTick(() => {
        const element = this.$refs[`questionScroll-${anchor}`][0];
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          window.scrollBy(0, element.getBoundingClientRect().top - 68);
        }
      });
    },
    handleChage(val, question) {
      //console.log(val, question);
      this.$emit("questionEvent", { checked: val, question });
    },
  },
};
</script>

<style lang="scss" scoped>
.questionsZoom {
  ::v-deep {
    span {
      font-size: var(--fontSize) !important;
    }
    .el-radio__inner {
      width: var(--width);
      height: var(--height);
    }
    .el-radio__inner::after {
      width: var(--radioWidth);
      height: var(--radioHeight);
    }
    .el-checkbox__inner {
      width: var(--width);
      height: var(--height);
    }
    .el-checkbox__inner::after {
      width: var(--checkboxWidth);
      height: var(--checkboxHeight);
      left: var(--checkboxLeft);
      border: none;
      border-bottom: var(--checkboxBorder) solid #FFF;
      border-right: var(--checkboxBorder) solid #FFF;
    }
  }
}

.questions {
  .item {
    padding: 10px 0;
    position: relative;
  }

  .item .exam-question {
    font-size: 16px;
    line-height: 36px;
    padding: 5px 0;

    position: relative;
  }

  .item .answers {
    overflow: auto;
  }

  .questions-list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .questions-list li {
    position: relative;
  }

  .questions-list li:hover {
    background-color: #ededed;
  }

  .questions-list li .context {
    display: flex;
    min-height: 32px;
    align-items: center;
  }

  .questions-list li .context ::v-deep .el-radio__label {
    font-size: 16px;
  }

  .questions-list li .context .el-radio {
    margin-right: 0px;
  }

  .questions-list li .context label {
    font-weight: normal;

    word-break: break-all;
    padding: 10px 5px;
    display: block;
    line-height: 1;
    font-size: 16px;
    transition: color 0.4s;
  }
}

.questions .item:not(:last-child) {
  border-bottom: 1px solid #dedede;
}
</style>